export default {
  login_until: localStorage.getItem('login_until'),
  login: localStorage.getItem('login'),
  user: null,
  jwt_token: null,
  snackbar: {
    open: false,
    text: '',
    color: 'success',
    timeout: 6000,
  }
};
